import React, { useState, useRef } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'; // Arrow icons for navigation
import Slider from 'react-slick';

// Import Slick Carousel CSS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const AerospaceInsightsCards = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const sliderRef = useRef(null); // Ref to control slider programmatically

  // Settings for the slick slider with auto-scrolling enabled
  const sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Default: 3 cards on large screens
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
    centerMode: true, 
    focusOnSelect: true,  
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2, // Two cards per row on tablets
          slidesToScroll: 1,
          centerMode: true, 
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1, // Show only one card on mobile
          slidesToScroll: 1,
          centerMode: false, // Disable centering for better fit
        },
      },
    ],
  };
  

  // Function to manually scroll to the next slide
  const goToNextSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  // Function to manually scroll to the previous slide
  const goToPrevSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Insights</h1>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          padding: '20px',
          backgroundColor: '#fff',
        }}
      >
        <div className="container">
          <div className="row">
            <Slider {...sliderSettings} ref={sliderRef} className="cards-slider">
              {/* Card 1 */}
              <div
                className="card-container  col-md-4  card-blue"
                onMouseEnter={() => setHoveredIndex(0)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <button className="brochure-btn"> Brochure</button>
                <h1 className="card-title" style={{ color: '#fff' }}>The Connected Flyer</h1>
                <p className="card-description" style={{ color: '#fff' }}>
                  Air Travel in the Digital Era
                </p>

              </div>

              {/* Card 2 */}
              <div
                className="card-container col-md-4 card-green"
                onMouseEnter={() => setHoveredIndex(1)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <button className="brochure-btn">Brochure</button>
                <h1 className="card-title" style={{ color: '#fff' }}>IPDP frameworks</h1>
                <p className="card-description" style={{ color: '#fff' }}>
                  Constant Improvements of stakeholders engagement scores
                </p>

              </div>

              {/* Card 3 */}
              <div
                className="card-container col-md-4 card-red"
                onMouseEnter={() => setHoveredIndex(2)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <button className="brochure-btn"> Brochure</button>
                <h1 className="card-title" style={{ color: '#fff' }}>Gen AI Tool</h1>
                <p className="card-description" style={{ color: '#fff' }}>
                  Continuous building of skill evolving market dynamics
                </p>

              </div>

              {/* Card 4 */}
              <div
                className="card-container col-md-4 card-yellow"
                onMouseEnter={() => setHoveredIndex(3)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <button className="brochure-btn"> Brochure</button>
                <h1 className="card-title" style={{ color: '#fff' }}>Obsolescence Management</h1>
                <p className="card-description" style={{ color: '#fff' }}>
                  Continuous building of skill evolving market dynamics
                </p>

              </div>
            </Slider>
            </div>
        


            {/* Button Container for Manual Navigation */}
            <div className="buttons-container" style={{ marginTop: '20px' }}>
              <button onClick={goToPrevSlide} className="arrow-button prev-button">
                <FaArrowLeft />
              </button>
              <button onClick={goToNextSlide} className="arrow-button next-button">
                <FaArrowRight />
              </button>
            </div>
          </div>
          </div>

          <style>{`


.brochure-btn {
  background-color: #ffead4; /* Adjust button color */
  color: #000;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 15px;
  transition: background-color 0.3s ease;
}

.brochure-btn:hover {
  background-color: #fff; /* Darker shade on hover */
}

        /* Slider Container */
        .slick-slider {
          position: relative;
          margin: auto;
          overflow: hidden;
          width: 100% !important; /* Ensure the slider takes up full width */
        }

       .slick-track {
  display: flex !important;
 
}

.slick-slide {
  margin: 0 !important; /* Remove margins between slides */
}

       /* Card Styles */
.card-container {
  display: flex;
  justify-content: center;
  align-items: center; /* Center the content vertically */
  width: 100% !important; /* Ensure the card container takes the full width */
  max-width: 259px; /* Set a maximum width for large screens */
  height: 250px;
  border: 1px solid #ccc;
  border-radius: 8px;
  text-align: center;
  transition: background-color 0.3s ease, opacity 0.3s ease;
  cursor: pointer;
  flex-direction: column;
  justify-content: center; /* Center the content vertically */
  overflow: hidden;
  padding: 20px; /* Add some padding for better spacing */
}

/* Background colors for different cards */
.card-blue {
  background-color: #E06666;
}

.card-green {
  background-color: #0ea9e1;
}

.card-red {
  background-color: #158B99;
}

.card-yellow {
  background-color: #0ea9e1;
}

/* Card Title Styles */
.card-title {
  font-size: 20px;
  margin-top: 10px;
  color: #333;
  margin-bottom: 10px; /* Add space below title */
}

/* Card Description Styles */
.card-description {
  margin-bottom: 10px;
  color: #666;
  flex-grow: 1; /* Make the description take the remaining space */
}

/* Brochure Button Styles */
.brochure-btn {
  background-color: #fe9900; /* Adjust button color */
  color: #000;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 15px;
  transition: background-color 0.3s ease;
}

/* Hover effect for Brochure Button */
.brochure-btn:hover {
  background-color: #fff; /* Darker shade on hover */
}

/* Media Queries for Responsive Design */
@media (max-width: 1024px) {
  .card-container {
    width: 300px; /* Adjust the width for medium screens */
  }
}

@media (max-width: 768px) {
  .card-container {
    width: 250px; /* Adjust the width for smaller screens */
  }
}
   .buttons-container {
                    display: flex;
                    justify-content: center;
                }

                .arrow-button {
                    background-color: #fe9900;
                    color: #000;
                    padding: 10px;
                    border: none;
                    cursor: pointer;
                    font-size: 20px;
                    margin: 10px;
                    border-radius: 50px;
                    width: 50px;
                    height: 50px;
                }

      `}</style>
        </div>
        );
};

        export default AerospaceInsightsCards;
